module.exports = __webpack_public_path__ + "weight_icon-f555d01310c3c820e925419dd1dd7bbf.png";